/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PendingInvitation = {
    id: number;
    email: string;
    role: PendingInvitation.role;
    invitedAt: string;
    invitedByFirstName: string | null;
    invitedByLastName: string | null;
};
export namespace PendingInvitation {
    export enum role {
        OWNER = 'owner',
        ADMIN = 'admin',
        PRACTITIONER = 'practitioner',
        ASSISTANT = 'assistant',
        VIEWER = 'viewer',
        THERAPIST = 'therapist',
        USER = 'user',
    }
}

